import { Box, useTheme } from '@chakra-ui/react';
import { useTableCellContext } from '../context';

const TableCellBar = () => {
  const theme = useTheme();
  const { lighterGrey, graphicRed, graphicGreen } = theme.colors;

  const context = useTableCellContext();

  if (context.cellType === 'bar') {
    const { valueOutside, valueBar, dataTestId } = context;

    return (
      <Box
        width='100%'
        display='block'
        paddingLeft='2px'
        data-testid={dataTestId || 'cjtable-cell-bar-id'}
      >
        <Box
          display='block'
          width={valueOutside}
          height='14px'
          position='relative'
          background={lighterGrey}
          borderTopRightRadius='3px'
          borderBottomRightRadius='3px'
          data-testid='cjtable-cell-bar-outside'
        />
        <Box
          display='block'
          width={valueBar}
          height='4px'
          background={valueBar > valueOutside ? graphicRed : graphicGreen}
          position='relative'
          bottom='9px'
          borderTopRightRadius='3px'
          borderBottomRightRadius='3px'
          data-testid='cjtable-cell-bar-inside'
        />
      </Box>
    );
  }
  return null;
};

export default TableCellBar;
